//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { stripQueryParam } from '~/plugins/url-funcs'

const redirect = ({ languageSegment, path, sessionId }) => (currentSubdomain, targetSubdomain) => {
  const target = new URL(window.location.href)
  target.host = target.host.replace(new RegExp(`^${currentSubdomain}.`, 'gi'), `${targetSubdomain}.`)
  target.pathname = `${languageSegment}${target.pathname}`

  // Delete old country and sg18pid params (even if they aren't set)
  target.searchParams.delete('country')
  target.searchParams.delete('sg18pid')

  // Set new params
  target.searchParams.append('country', targetSubdomain)
  target.searchParams.append('sg18pid', sessionId)

  window.location = target.toString()
  return true
}

const getAllAvailableStores = (acc, store) =>
  store.currency === 'GBP'
    ? [...acc, 'gb']
    : [...acc, ...store.subdomains]

const getBrowserLocales = () => {
  const browserLocales =
    navigator.languages === undefined
      ? [navigator.language]
      : navigator.languages

  if (!browserLocales) return 'en'
  return browserLocales.map(locale => locale.trim().split(/-|_/)[0])
}

export default {
  async fetch () {
    await Promise.all([
      this.$store.dispatch('review/GET_SUMMARY'),
      this.$store.dispatch('review/GET_ALL_PRODUCT_SUMMARIES'),
      this.$store.dispatch('store/GET_SHIPPING_CONFIG'),
      this.$store.dispatch('url/RESOLVE_COMMON_ROUTES'),
      this.$store.dispatch('product/GET_ALL_PRODUCT_DETAILS'),
      this.$store.dispatch('product/GET_LE_PRODUCT_CONFIG'),
      this.$store.dispatch('product/GET_PDP_MAPPING'),
      this.$store.dispatch('product/GET_ALL_PRODUCT_IMAGES'),
      this.$store.dispatch('store/GET_SHIPPING_LIST'),
      this.$store.dispatch('flag/GET_ALL'),
      this.$store.dispatch('product/GET_ALL_STOCK'),
      this.$store.dispatch('promo/GET_PROMOS', true)
    ])
  },
  head () {
    // Start with the default nuxt-i18n tags
    const tags = this.$nuxtI18nSeo()

    // Add hreflang alternate tags (since we're using a custom URL strategy)
    tags.link = [
      ...tags.link,
      {
        rel: 'alternate',
        href: this.$route.path,
        hreflang: 'x-default',
        hid: 'i18n-xd'
      },
      ...this.$i18n.locales.map(locale => ({
        rel: 'alternate',
        href: `${this.$route.path}?lang=${locale.code}`,
        hreflang: locale.iso,
        hid: `i18n-alt-${locale.code}`
      }))
    ]

    // Set title
    tags.title = this.getTitle(this.cmsDetails.title)

    // Add opengraph metadata
    tags.meta = [
      ...tags.meta, {
        hid: 'og:url',
        property: 'og:url',
        content: `https://www.sungod.co${this.$route.path}`
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.getTitle(this.cmsDetails.title)
      },
      ...this.getDescription('We exist to make Life Look Better. Our sunglasses and goggles are built to enhance your adventures, your early morning rides, your evening runs and your waist-deep powder days.')
    ]

    return tags
  },
  computed: {
    ...mapGetters({
      isMobileMenuOpen: 'page/isMobileMenuOpen',
      isCurrencyMenuOpen: 'page/isCurrencyMenuOpen',
      showCookieModal: 'page/showCookieModal',
      showTranslationBanner: 'translations/showTranslationBanner',
      cookiesChecked: 'page/cookiesChecked',
      cookiesAllowed: 'page/cookiesAllowed',
      country: 'store/country',
      subdomain: 'store/subdomain',
      euroCountries: 'store/euroCountries',
      stores: 'store/stores',
      cartItems: 'cart/itemCount',
      pageTheme: 'page/pageTheme',
      contentPreviewEnabled: 'page/contentPreviewEnabled',
      preventBodyScroll: 'page/preventBodyScroll'
    }),
    baseClass () {
      return this.$route.path.replace(/^\/|\/$/g, '').replace(/\//g, '-') + '-index'
    },
    cmsDetails () {
      return this.$store.getters['url/cmsDetails'](this.$route.path.substring(1))
    },
    showHeader () {
      return !['sungod18/typeform'].includes(this.cmsDetails.custom_theme)
    },
    showFooter () {
      let showFooter = true
      showFooter &= !['sungod18/typeform'].includes(this.cmsDetails.custom_theme)
      showFooter &= !this.$route.path.includes('support/contact-us')
      return showFooter
    }
  },
  watch: {
    email () {
      this.identifyWithKlaviyo()
      this.identifyWithLD()
    },
    preventBodyScroll () {
      this.updateHTMLClasses()
    }
  },
  async beforeMount () {
    await this.handleNewSession()
  },
  async mounted () {
    try {
      this.identifyWithKlaviyo()
      this.identifyWithLD()
    } catch (error) {
      console.error(error)
      this.$sentry.captureException(error)
    }

    await Promise.all([
      this.$store.dispatch('product/GET_ALL_STOCK'),
      this.$store.dispatch('cart/GET_CART_STATE', true),
      this.$store.dispatch('promo/GET_PROMOS')
    ])

    if (this.preventBodyScroll) {
      this.updateHTMLClasses()
    }
  },
  methods: {
    async getUserCountry () {
      try {
        const { data: userGeo } = await this.$axios.get(this.$config.geoLookupUrl, { timeout: 1000 })
        return userGeo.code
      } catch (error) {
        return 'GB' // Default to assuming they're in the UK
      }
    },
    redirectionTest (country, sessionId) {
      // try {
      const allLangs = this.$i18n.locales.map(l => l.code)
      const language = getBrowserLocales().find(lang => allLangs.includes(lang)) || 'en'
      const isLocalePath = allLangs.some(lang => this.$route.fullPath.startsWith(`/${lang}/`))
      const targetLang = !isLocalePath && language !== 'en' ? `/${language}` : ''

      const availableStores = Object.values(this.stores).reduce(getAllAvailableStores, [])
      const isEuroCountry = this.euroCountries.includes(country)
      const isGlobalCountry = availableStores.includes(country) // Country has a direct subdomain eg AU -> au.sungod.co

      // Don't redirect if the current subdomain isn't recognised - prevents redirection in dev
      if (!availableStores.includes(this.subdomain)) return false

      // Don't redirect if it's specifically denied
      if (this.$route.query.redirect === 'false') return false

      // Don't redirect from any paypal return routes
      if (this.$route.fullPath.includes('paypal')) return false

      const redirectWithPath = redirect({
        languageSegment: targetLang,
        path: this.$route.fullPath,
        sessionId
      })

      // Resolve expected subdomain and redirect if there's a mismatch
      let expectedSubdomain = 'www'
      if (isGlobalCountry) expectedSubdomain = country.toLowerCase()
      else if (isEuroCountry) expectedSubdomain = 'eu'

      if (expectedSubdomain !== this.subdomain) {
        return redirectWithPath(this.subdomain, expectedSubdomain)
      }

      // Check browser language and redirect if there's a mismatch
      if (!isLocalePath && targetLang) return redirectWithPath(this.subdomain, expectedSubdomain)

      return false
    },
    async handleNewSession () {
      this.$store.commit('session/SET_USER_AGENT', navigator.userAgent)

      const { sessionId, hasGenerated } = this.getSessionId()
      const sessionDetails = !hasGenerated ? await this.getSessionDetails(sessionId) : {}
      this.getEmail(sessionDetails)

      // Get subdomain from query param or sessionDetails - these are really poorly named.
      const countryQueryParam = (this.$route.query.country || '').split(',')[0]
      const requestedSubdomain = countryQueryParam || sessionDetails.country

      // If requestedSubdomain isn't set or isn't a valid country (eg if we switch to eu.sungod.co the country will be 'eu')
      // then get the true country from a geo lookup service
      const userCountry = requestedSubdomain && this.$store.getters['store/validCountryCode'](requestedSubdomain)
        ? requestedSubdomain
        : await this.getUserCountry()

      // Check user is on correct subdomain and locale
      this.$store.commit('store/SET_SUBDOMAIN', window.location.host.split('.')[0])
      if (this.redirectionTest(requestedSubdomain || userCountry, sessionId)) return

      this.$store.commit('store/SET_COUNTRY', (userCountry || 'GB').toUpperCase())
      this.$store.commit('store/CHANGE_SHIPPING_COUNTRY', sessionDetails.country_ship || userCountry)

      await this.checkReferrer({ sessionId, hasGenerated })

      // Check if a discount should be auto-applied
      this.getPromoFromURL()
    },
    getSessionId () {
      // Get current sg18PID
      let sessionId = this.$route.query.acsid ||
        this.$route.query.sg18PID ||
        this.$route.query.sg18pid ||
        this.$store.getters['store/sg18pid'] ||
        this.$cookies.get('_sg18PID')

      // If sg18PID still is not set then generate a new one
      let hasGenerated = false
      if (!sessionId) {
        hasGenerated = true
        sessionId = this.$store.commit('store/CREATE_SG18PID')
      }

      // Check the stored value is up to date
      if (sessionId !== this.$store.getters['store/sg18pid']) {
        this.$log.debug(`New sg18PID detected: ${sessionId}`, 'Layout')
        this.$store.commit('store/SET_SG18PID', sessionId)
      }

      stripQueryParam(this.$route, 'acsid')
      stripQueryParam(this.$route, 'sg18PID')

      return { sessionId, hasGenerated }
    },
    async getSessionDetails (sessionId) {
      if (this.$store.getters['session/ignore']) return {}

      // Get session details from server
      try {
        const { data } = await this.$publicAPI.quietGet(`session/${sessionId}/`)
        return data
      } catch (error) {
        if (!error.response || parseInt(error.response.status) !== 404) {
          // Errors are only interesting if they're not 404
          this.$sentry.captureException(error)
        }
      }

      return {}
    },
    async checkReferrer ({ sessionId, hasGenerated }) {
      if (this.$store.getters['session/ignore']) return

      /**
       * Check for ?rl= query parameter, if present then track the view
       */
      const rl = this.$route.query.rl || ''
      const landingPage = hasGenerated ? this.$route.path : ''

      // If no rl query parameter was given and this isn't a new session then bail now
      if (!hasGenerated && !rl) return

      try {
        await this.$store.dispatch('session/TRACK_LANDING', { rl, landingPage })
      } catch (error) {
        this.$log.error(error, 'Layout')
        this.$sentry.captureException(error)
      }
    },
    getEmail (sessionDetails) {
      // Try to get email from emailAd query parameter
      let email = this.$route.query.emailAd

      // Try to get email from _ke query parameter
      if (!email && this.$route.query._ke) {
        try {
          email = JSON.parse(Buffer.from(this.$route.query._ke, 'base64').toString()).kl_email
        } catch (error) {
          this.$log.error(error, 'Layout')
          this.$sentry.captureException(error)
        }
      }

      // If we don't know the email already then try to get it from the sessions database
      if (!email && !this.$store.getters['store/email']) {
        email = sessionDetails.email
      }

      // Store the email if we've got it
      if (email) this.$store.commit('store/SET_EMAIL', email)
    },
    identifyWithKlaviyo () {
      const _learnq = window._learnq || []
      _learnq.push(['identify', { $email: this.email, language: this.locale, currency: this.storeCurrency }])
    },
    identifyWithLD () {
      if (this.$store.getters['session/ignore']) this.$ld.identify({ newUser: { key: 'bot' } })
      else if (this.email) this.$ld.identify({ newUser: { key: this.email } })
      else this.$ld.identify({ newUser: { anonymous: true } })
    },
    getPromoFromURL () {
      const encodedDetails = this.$route.query.d
      if (!encodedDetails) return

      let details
      try {
        details = JSON.parse(Buffer.from(encodedDetails, 'base64').toString())
      } catch (error) {
        console.error(error)
        this.$sentry.captureException(error)
        return
      }

      if (this.$route.query.applyCode) details.code = this.$route.query.applyCode

      this.$store.commit('promo/ADD_ACTIVE_PROMO', details)
    },
    updateHTMLClasses () {
      const htmlElem = document.querySelector('html')
      htmlElem.classList.toggle('no-scroll', this.preventBodyScroll)
    }
  }
}
